jQuery(document).ready(function ($) {
    console.log('custom js loaded');

    let thumbsSwiper;
    let mainSwiper;

    if ($(window).width() > 991) {
        // Desktop
        thumbsSwiper = new Swiper(".thumbnail-images", {
            spaceBetween: 16,
            slidesPerView: 3,
            watchOverflow: true,
            navigation: false, // handled manually below
        });

        mainSwiper = new Swiper(".top-img-wrapper", {
            spaceBetween: 10,
            slidesPerView: 1,
            navigation: {
                nextEl: ".next-arrow",
                prevEl: ".prev-arrow",
            },
            scrollbar: {
                el: ".prod-images .swiper-scrollbar",
            },
        });

        // 👉 desktop: manual control of thumbs
        $(".next-arrow").on("click", function (e) {
            e.preventDefault();
            thumbsSwiper.slideNext();
        });
        $(".prev-arrow").on("click", function (e) {
            e.preventDefault();
            thumbsSwiper.slidePrev();
        });

    } else {
        // Mobile
        thumbsSwiper = new Swiper(".thumbnail-images", {
            spaceBetween: 16,
            slidesPerView: 1,
            watchOverflow: true,
            navigation: {
                nextEl: ".next-arrow",
                prevEl: ".prev-arrow",
            },
            scrollbar: {
                el: ".prod-images .swiper-scrollbar",
            },
        });

        // ❌ no manual arrow handlers here, since Swiper already handles it
    }

    // 👉 sync main to thumbs
    if (mainSwiper) {
        mainSwiper.on("slideChange", function () {
            const idx = this.activeIndex;

            // move thumbnails
            thumbsSwiper.slideTo(idx);

            // update active class
            $(".thumbnail-images .swiper-slide")
                .removeClass("thumb-active")
                .eq(idx).addClass("thumb-active");
        });
    }

    // 👉 sync thumbs to main
    $(".thumbnail-images").on("click", ".swiper-slide", function () {
        const idx = $(this).index();
        if (mainSwiper) mainSwiper.slideTo(idx);
    });

    $(".thumbnail-images .swiper-slide").eq(0).addClass("thumb-active");
});
